/* REBROWN 테마 동작: 헤더, 장바구니 담기, 스크롤 스토리, 상품 사진 물방울, 나타나는 효과 */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const smooth = x => x * x * (3 - 2 * x);
  const strings = window.RB_STRINGS || {};

  // 로딩 화면이 어떤 이유로든 남아 있지 않도록 (물방울 엔진이 없을 때 등)
  setTimeout(() => { const l = $('#rb-loader'); if (l) l.classList.add('is-done'); }, 5000);

  // ---------------- 헤더
  const header = $('.rb-header');
  const onScroll = () => header && header.classList.toggle('is-scrolled', scrollY > 8);
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  document.addEventListener('click', e => {
    const open = e.target.closest('[data-rb-menu-open]'), close = e.target.closest('[data-rb-menu-close]');
    const drawer = $('#rb-drawer');
    if (!drawer) return;
    if (open) { drawer.hidden = false; requestAnimationFrame(() => drawer.classList.add('is-open')); open.setAttribute('aria-expanded', 'true'); $('a, button', drawer)?.focus(); }
    if (close) { drawer.classList.remove('is-open'); setTimeout(() => { drawer.hidden = true; }, 450); $('[data-rb-menu-open]')?.setAttribute('aria-expanded', 'false'); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') $('[data-rb-menu-close]')?.click(); });

  // ---------------- 장바구니 담기 (페이지 이동 없이)
  let toastTimer;
  function toast(html) {
    let el = $('.rb-toast');
    if (!el) { el = document.createElement('div'); el.className = 'rb-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.innerHTML = html; el.classList.add('is-show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('is-show'), 3200);
  }
  async function refreshCount() {
    try {
      const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
      $$('[data-rb-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    } catch (e) {}
  }
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-rb-add]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type=submit]', form);
    if (btn) btn.disabled = true;
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || strings.addError);
      toast(`${strings.added || 'Added to cart.'} <a href="${(window.Shopify?.routes?.root || '/')}cart">${strings.viewCart || 'View cart'}</a>`);
      refreshCount();
    } catch (err) {
      toast(err.message || strings.addError || 'Could not add to cart.');
    } finally { if (btn) btn.disabled = false; }
  });

  // 저널 글 링크 복사
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-rb-copy-link]');
    if (!b) return;
    try { await navigator.clipboard.writeText(location.href); toast('링크를 복사했어요.'); }
    catch (err) { toast(location.href); }
  });

  // 수량 + / −
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-rb-qty]');
    if (!b) return;
    const input = $('input', b.closest('.rb-qty'));
    input.value = Math.max(+input.min || 0, (+input.value || 0) + (+b.dataset.rbQty));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---------------- 상품 상세: 옵션 → 가격·재고, 사진 → 물방울 속 사진 교체
  function initProduct(root) {
    const dataEl = $('[data-rb-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = $('form[data-rb-add]', root), idInput = $('input[name="id"]', form);
    const selects = $$('[data-rb-option]', root), priceEl = $('[data-rb-price]', root), btn = $('[type=submit]', form);
    const bubble = $('.rb-product__bubble', root);
    const swapImage = url => { // 사진이 겹쳐 부드럽게 바뀜
      if (!bubble || !url || bubble.dataset.img === url) return;
      bubble.dataset.img2 = bubble.dataset.img || ''; bubble.dataset.alpha2 = '1';
      bubble.dataset.img = url; bubble.dataset.alpha = '0';
      const t0 = performance.now();
      const step = now => {
        const k = clamp((now - t0) / 700, 0, 1);
        bubble.dataset.alpha = smooth(k).toFixed(3); bubble.dataset.alpha2 = (1 - smooth(k)).toFixed(3);
        if (k < 1) requestAnimationFrame(step); else delete bubble.dataset.img2;
      };
      requestAnimationFrame(step);
      const img = $('img', bubble); if (img) img.src = url;
    };
    const update = () => {
      const chosen = selects.map(s => s.value);
      const v = variants.find(v => v.options.every((o, i) => o === chosen[i]));
      if (!v) { btn.disabled = true; btn.textContent = strings.unavailable || 'Unavailable'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      btn.disabled = !v.available;
      btn.textContent = v.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      if (v.image) swapImage(v.image);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    };
    selects.forEach(s => s.addEventListener('change', update));
    $$('[data-rb-thumb]', root).forEach(t => t.addEventListener('click', () => {
      $$('[data-rb-thumb]', root).forEach(x => x.setAttribute('aria-current', x === t ? 'true' : 'false'));
      swapImage(t.dataset.rbThumb);
    }));
  }

  // ---------------- 스크롤 스토리: 흩어진 방울이 모여 큰 방울이 되고, 단계마다 제품·위치가 바뀜
  const stories = new Set();
  function initStory(root) {
    const steps = $$('.rb-story__step', root);
    if (!steps.length) return;
    const st = {
      root, steps, track: $('.rb-story__track', root), bubble: $('.rb-story__bubble', root),
      drops: $$('.rb-story__drop', root), dots: $$('.rb-story__dots li', root), numEl: $('[data-rb-story-num]', root),
      sticky: $('.rb-story__sticky', root), head: $('.rb-story__head', root),
      data: steps.map(s => ({ x: +s.dataset.x / 100, y: +s.dataset.y / 100, scale: +s.dataset.scale / 100, img: s.dataset.img, url: s.dataset.url, title: s.dataset.title })),
      active: -1,
    };
    stories.add(st);
  }
  function runStories() {
    stories.forEach(st => {
      if (!st.root.isConnected) { stories.delete(st); return; }
      const rc = st.track.getBoundingClientRect(), vh = innerHeight, vw = innerWidth;
      if (rc.bottom < -vh || rc.top > vh * 2) return;
      const n = st.data.length, total = Math.max(1, st.track.offsetHeight - vh);
      const prog = clamp(-rc.top / total, 0, 1) * (n + 1); // 0~1: 모이는 구간, 1~n+1: 단계별
      const enter = clamp(prog, 0, 1), f = prog - 1;
      const mobile = vw <= 760;
      // 어느 단계 사이에 있는지 (각 단계 가운데 절반은 머물고, 나머지 절반 동안 다음 단계로 이동)
      const cont = clamp(f - .5, 0, n - 1), i0 = Math.min(n - 1, Math.floor(cont)), i1 = Math.min(n - 1, i0 + 1);
      const ease = i0 === i1 ? 0 : smooth(clamp((cont - i0 - .25) / .5, 0, 1));
      const A = st.data[i0], B = st.data[i1];
      // 모바일: 위 제목과 아래 글 사이 빈 공간의 한가운데에 물방울
      let gapTop = vh * .2, gapBot = vh * .62, sh = vh;
      if (mobile && st.sticky && st.head) {
        const top0 = st.sticky.getBoundingClientRect().top; sh = st.sticky.offsetHeight || vh;
        gapTop = st.head.getBoundingClientRect().bottom - top0;
        // 단계마다 글 길이가 달라도 물방울이 움직이지 않게, 가장 긴 글의 윗선 기준 (translate 영향 없는 offsetTop 사용)
        const box = st.steps[0].offsetParent, boxTop = box ? box.getBoundingClientRect().top - top0 : 0;
        const tops = st.steps.map(s => boxTop + s.offsetTop).filter(t => t > gapTop);
        if (tops.length) gapBot = Math.min(...tops);
      }
      const px = mobile ? .5 : A.x + (B.x - A.x) * ease, py = mobile ? (gapTop + gapBot) / 2 / sh : A.y + (B.y - A.y) * ease;
      const sc = mobile ? 1 : A.scale + (B.scale - A.scale) * ease; // 모바일은 빈 공간에 꼭 맞게 크기 고정
      const base = mobile ? Math.max(120, Math.min(vw * .72, (gapBot - gapTop) * .86)) : Math.min(vw * .34, vh * .62, 520);
      const grow = .35 + .65 * smooth(enter);
      const b = st.bubble;
      b.style.left = px * 100 + '%'; b.style.top = py * 100 + '%';
      b.style.width = base * sc + 'px';
      b.dataset.vis = grow.toFixed(3);
      // 방울 속 사진: 두 장을 겹쳐 교체
      const show = smooth(clamp((enter - .55) / .45, 0, 1));
      b.dataset.img = A.img || ''; b.dataset.alpha = ((1 - ease) * show).toFixed(3);
      if (i1 !== i0 && B.img) { b.dataset.img2 = B.img; b.dataset.alpha2 = (ease * show).toFixed(3); } else delete b.dataset.img2;
      const cur = ease < .5 ? A : B;
      if (cur.url) { b.href = cur.url; b.setAttribute('aria-label', cur.title || ''); }
      const fb = $('img', b); if (fb && cur.img && fb.getAttribute('src') !== cur.img) fb.src = cur.img;
      // 흩어진 작은 방울 → 큰 방울로 빨려 들어감
      st.drops.forEach((d, k) => {
        const sx = +d.dataset.sx / 100, sy = +d.dataset.sy / 100;
        const m = smooth(clamp((enter - k * .06) / .7, 0, 1));
        d.style.left = (sx + (px - sx) * m) * 100 + '%'; d.style.top = (sy + (py - sy) * m) * 100 + '%';
        d.dataset.vis = (1 - smooth(clamp((m - .7) / .3, 0, 1))).toFixed(3);
      });
      // 글: 지금 단계만 보이고, 물방울 반대편으로
      const active = Math.round(cont);
      st.steps.forEach((s, k) => {
        const a = clamp(1 - Math.abs(cont - k) * 2.4, 0, 1) * smooth(clamp((enter - .6) / .4, 0, 1));
        s.style.opacity = a.toFixed(3);
        s.style.translate = `0 ${((k - cont) * 40).toFixed(1)}px`;
        s.classList.toggle('is-active', k === active && a > .5);
      });
      st.root.classList.toggle('is-left', !mobile && px > .5);
      if (active !== st.active) {
        st.active = active;
        st.dots.forEach((d, k) => d.classList.toggle('is-active', k === active));
        if (st.numEl) st.numEl.textContent = String(active + 1);
      }
    });
    requestAnimationFrame(runStories);
  }
  requestAnimationFrame(runStories);

  // ---------------- 브랜드 철학: 라벨과 물방울을 잇는 선을 실제 위치로 계산해서 그림
  // 라벨의 물방울 쪽 끝(점) → 물방울 중심을 향한 방향으로 테두리까지
  const SVGNS = 'http://www.w3.org/2000/svg';
  function initPhilo(stage) {
    const bubble = $('.rb-philo__bubble', stage), calls = $$('.rb-call', stage);
    if (!bubble || !calls.length) return;
    let svg = $('svg.rb-philo__lines', stage);
    if (!svg) { svg = document.createElementNS(SVGNS, 'svg'); svg.setAttribute('class', 'rb-philo__lines'); svg.setAttribute('aria-hidden', 'true'); stage.prepend(svg); }
    const draw = () => {
      svg.replaceChildren();
      if (getComputedStyle(svg).display === 'none') return; // 좁은 화면: 라벨이 아래로 쌓여 선이 필요 없음
      const s = stage.getBoundingClientRect(), b = bubble.getBoundingClientRect();
      svg.setAttribute('viewBox', `0 0 ${s.width} ${s.height}`);
      const cx = b.left + b.width / 2 - s.left, cy = b.top + b.height / 2 - s.top, r = b.width / 2;
      calls.forEach(call => {
        const c = call.getBoundingClientRect(), label = $('.rb-call__label', call) || call;
        // 칸 전체가 아니라 실제 글자가 차지하는 영역 (글자 끝에서 선이 시작되도록)
        const range = document.createRange(); range.selectNodeContents(label);
        const l = range.getBoundingClientRect();
        const leftSide = c.left + c.width / 2 - s.left < cx;
        // 시작점: 라벨 글자의 물방울 쪽 끝에서 살짝 띄운 곳, 높이는 라벨 글자 가운데
        const x1 = (leftSide ? l.right + 12 : l.left - 12) - s.left;
        const y1 = l.top + l.height / 2 - s.top;
        // 끝점: 물방울 중심을 향해 가다가 테두리에서 멈춤
        const dx = cx - x1, dy = cy - y1, len = Math.hypot(dx, dy) || 1;
        if (len <= r + 8) return; // 라벨이 물방울 안쪽이면 선을 그리지 않음
        const x2 = cx - dx / len * r * 1.02, y2 = cy - dy / len * r * 1.02;
        const line = document.createElementNS(SVGNS, 'line');
        Object.entries({ x1, y1, x2, y2, class: 'rb-philo__line' }).forEach(([k, v]) => line.setAttribute(k, v));
        line.style.setProperty('--len', Math.hypot(x2 - x1, y2 - y1).toFixed(1));
        const dot = (x, y, cls) => { const e = document.createElementNS(SVGNS, 'circle'); e.setAttribute('cx', x); e.setAttribute('cy', y); e.setAttribute('r', cls === 'is-start' ? 3 : 2.5); e.setAttribute('class', 'rb-philo__dot ' + cls); return e; };
        svg.append(line, dot(x1, y1, 'is-start'), dot(x2, y2, 'is-end'));
      });
    };
    draw();
    if ('ResizeObserver' in window) new ResizeObserver(draw).observe(stage);
    addEventListener('resize', draw);
    document.fonts && document.fonts.ready.then(draw); // 글꼴이 바뀌면 라벨 폭이 달라지므로 다시
    // 화면에 들어오면 선이 라벨에서 물방울 쪽으로 그어짐
    if (io2) io2.observe(stage); else stage.classList.add('is-in');
  }
  const io2 = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io2.unobserve(e.target); }
  }), { threshold: .3 }) : null;

  // ---------------- 나타나는 효과
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -10% 0px' }) : null;
  const initReveal = root => $$('.rb-reveal', root).forEach(el => io ? io.observe(el) : el.classList.add('is-in'));

  // ---------------- 시작 + 테마 편집기에서 섹션을 바꿨을 때 다시 연결
  const init = root => {
    initReveal(root);
    $$('[data-rb-story]', root).forEach(initStory);
    $$('[data-rb-product]', root).forEach(initProduct);
    $$('.rb-philo__stage', root).forEach(initPhilo);
  };
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
